import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Car from './car';
import CarBox from './carBox';
import Items from './items';
import Gem from './gem';
import { classNameStrings } from '../../../../constants/base';

function MarketMain() {
  // -- props --//

  // -- component const --//
  const title = '마켓'

  // -- useSelector & dispatch --//

  // -- state --//
  const [className, setClassName] = useState('tab1');

  // -- func & handler --//

  // -- react hooks --//

  // -- render --//

  return (
    <div className='page'>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSection flowRoot">
        <div className="leftSection">
          <p className="titleText">
            {title}
          </p>
        </div>

        <div className="rightSection">
          <button
            className={className === 'tab1' ? 'tab1 active' : 'tab1'}
            onClick={() => setClassName('tab1')}
          >
            차량
          </button>
          <button
            className={
              className === 'tab2' ? 'tab2 active' : 'tab2'
            }
            onClick={() => setClassName('tab2')}
          >
            차량 상자
          </button>
          <button
            className={
              className === 'tab3' ? 'tab3 active' : 'tab3'
            }
            onClick={() => setClassName('tab3')}
          >
            아이템
          </button>
          <button
            className={
              className === 'tab4' ? 'tab4 active' : 'tab4'
            }
            onClick={() => setClassName('tab4')}
          >
            보석
          </button>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <div className="divTaps">
        {className === 'tab1' && <Car />}
        {className === 'tab2' && <CarBox />}
        {className === 'tab3' && <Items />}
        {className === 'tab4' && <Gem />}
      </div>
    </div>
  );
}

export default MarketMain;
